/*
 *
 * */

import FilterFactory from '@/lib/filterFactory';
import { ADMIN_ROLES } from '@/store/user';

const enum FilterKey {
    Name = 'fullName',
    Doctor = 'doctorId',
    Clinic = 'clinicId',
    WithInactive = 'withInactive',
    WhereIsMobile = 'whereIsMobile',
}

export default class PatientsFilter {
    filterHandlers = {
        update: 'patientsFilter/updateFilter',
        reset: 'patientsFilter/resetFilter',
        resetState: 'patientsFilter/resetFilterState',
        removeSelected: 'patientsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createSearchEntity(FilterKey.Name);
        filter.setPlaceholder(FilterKey.Name, 'По имени');
        filter.setName(FilterKey.Name, 'search_patientsName');
        filter.setPreviewName(FilterKey.Name, 'Имя');
        filter.setClassName(FilterKey.Name, 'col-1-row-1');
        filter.setIconClassName(FilterKey.Name, 'icon-profile');
        filter.setAction(FilterKey.Name, 'patientsFilter/updateSearch');

        filter.createAutocompleteEntity(FilterKey.Doctor);
        filter.setPlaceholder(FilterKey.Doctor, 'По врачу');
        filter.setName(FilterKey.Doctor, 'search_patientsDoctor');
        filter.setPreviewName(FilterKey.Doctor, 'Врач');
        filter.setClassName(FilterKey.Doctor, 'col-2-row-1');
        filter.setIconClassName(FilterKey.Doctor, 'icon-clients');
        filter.setAction(FilterKey.Doctor, 'patientsFilter/updateSearch');
        filter.setRoles(FilterKey.Doctor, ADMIN_ROLES);
        filter.setLoad(FilterKey.Doctor, {
            entityName: 'doctors',
            filterName: 'fullName'
        });

        filter.createAutocompleteEntity(FilterKey.Clinic);
        filter.setPlaceholder(FilterKey.Clinic, 'По клинике');
        filter.setName(FilterKey.Clinic, 'search_patientsClinic');
        filter.setPreviewName(FilterKey.Clinic, 'Клиника');
        filter.setClassName(FilterKey.Clinic, 'col-1-row-2');
        filter.setIconClassName(FilterKey.Clinic, 'icon-store');
        filter.setAction(FilterKey.Clinic, 'patientsFilter/updateSearch');
        filter.setRoles(FilterKey.Clinic, ADMIN_ROLES);
        filter.setLoad(FilterKey.Clinic, {
            entityName: 'clinics',
        });

        filter.createCheckboxEntity(FilterKey.WithInactive);
        filter.setName(FilterKey.WithInactive, 'checkbox_activity');
        filter.setPreviewName(FilterKey.WithInactive, 'Неактив');
        filter.setIconClassName(FilterKey.WithInactive, 'icon-check-mark');
        filter.setClassName(FilterKey.WithInactive, 'col-2-row-2');
        filter.setCheckboxList(FilterKey.WithInactive, [
            {
                id: '0',
                name: 'Показывать деактивированные',
                value: FilterKey.WithInactive,
                checked: false,
            }
        ]);
        filter.setAction(FilterKey.WithInactive, 'patientsFilter/updateCheckbox');

        filter.createCheckboxEntity(FilterKey.WhereIsMobile);
        filter.setName(FilterKey.WhereIsMobile, 'checkbox_activity');
        filter.setPreviewName(FilterKey.WhereIsMobile, 'Только мобильные');
        filter.setIconClassName(FilterKey.WhereIsMobile, 'icon-check-mark');
        filter.setClassName(FilterKey.WhereIsMobile, 'col-2-row-3');
        filter.setCheckboxList(FilterKey.WhereIsMobile, [
            {
                id: '1',
                name: 'Только мобильные',
                value: FilterKey.WhereIsMobile,
                checked: false,
            }
        ]);
        filter.setAction(FilterKey.WhereIsMobile, 'patientsFilter/updateCheckbox');

        this.filterModel = filter.filterModel;
    }
}
